import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../lib/i18n';
export function Author() {
  const {
    t
  } = useI18n();
  const sections = [{
    title: t('author.vision'),
    text: t('author.visionText')
  }, {
    title: t('author.research'),
    text: t('author.researchText')
  }, {
    title: t('author.approach'),
    text: t('author.approachText')
  }];
  return <section className="w-full bg-[#05060A] py-32 px-6 md:px-12 border-t border-white/5" data-id="element-51">
      <div className="max-w-6xl mx-auto" data-id="element-52">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-5xl font-light text-white mb-16 tracking-tight" data-id="element-53">
          {t('author.title')}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start" data-id="element-54">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="md:col-span-1" data-id="element-55">
            <div className="aspect-square w-full max-w-xs bg-white/[0.02] border border-white/10 rounded-2xl p-6 flex items-center justify-center relative overflow-hidden" data-id="element-56">
              <svg viewBox="0 0 200 200" className="w-full h-full" aria-hidden="true" data-id="element-57">
                <defs data-id="element-58">
                  <radialGradient id="authorGlow" cx="50%" cy="40%" data-id="element-59">
                    <stop offset="0%" stopColor="#7C3AED" stopOpacity="0.4" data-id="element-60" />
                    <stop offset="100%" stopColor="#7C3AED" stopOpacity="0" data-id="element-61" />
                  </radialGradient>
                </defs>
                <circle cx="100" cy="100" r="90" fill="url(#authorGlow)" data-id="element-62" />
                <circle cx="100" cy="100" r="60" fill="none" stroke="#A855F7" strokeOpacity="0.3" strokeWidth="0.5" data-id="element-63" />
                <circle cx="100" cy="100" r="40" fill="none" stroke="#A855F7" strokeOpacity="0.5" strokeWidth="0.5" data-id="element-64" />
                <text x="100" y="108" textAnchor="middle" fill="#fff" fontSize="28" fontFamily="ui-monospace, monospace" fontWeight="300" data-id="element-65">
                  LGR
                </text>
              </svg>
            </div>
            <div className="mt-6" data-id="element-66">
              <h3 className="text-xl text-white font-light" data-id="element-67">
                Lionel Gustavo Raggio
              </h3>
              <p className="text-sm text-white/50 mt-2 leading-relaxed" data-id="element-68">
                {t('author.role')}
              </p>
            </div>
          </motion.div>

          <div className="md:col-span-2 space-y-10" data-id="element-69">
            {sections.map((s, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="border-l border-violet-500/40 pl-6" data-id="element-70">
                <h4 className="text-xs uppercase tracking-widest text-violet-400 mb-3" data-id="element-71">
                  {s.title}
                </h4>
                <p className="text-base text-white/70 leading-relaxed font-light" data-id="element-72">
                  {s.text}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}